import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import { COMMUNITY_MEMBER_ROLES_RESOURCE } from '../../constants';
import apiRoutes from '../../../../app/api/routes';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: COMMUNITY_MEMBER_ROLES_RESOURCE,
      method: 'get',
      request: (communityId, organisationId, t) => ({
        url: apiRoutes.communityMemberRoles(communityId, organisationId),
        meta: {
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getCommunityMemberRolesFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);
